/**
 * Calculate final booking total (same logic as backend)
 * @param {Object} booking - Booking object
 * @returns {number} - Final booking total
 */
export const getFinalBookingTotal = (booking) => {
  if (booking?.custom_price > 0) {
    return (
      (booking.custom_price || 0) +
      (booking.activity_price || 0) +
      (booking.activity_tax || 0)
    );
  }
  return booking?.total_price || 0;
};